import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 2.5rem;
  margin-top: 1.8rem;
`;

export const Subtitle = styled.p`
  margin: 6px 0;
  color: #dadada;
  font-size: 1.1rem;
`;

export const Info = styled.p`
  margin-bottom: 1.8rem;
  color: #888;
  font-size: 0.9rem;
`;

export const PhotoLegend = styled.p`
  margin-bottom: 1.8rem;
  margin-top: 0.6rem;
  font-size: 0.8rem;
  color: #888;
  text-align: center;
`;

export const EndText = styled.div`
  margin: 2.5rem 0;
  text-align: center;
  font-size: 1.3rem;
  font-family: 'PT Serif', serif;

  & .first {
    font-family: 'PT Serif', serif;
    display: block;
    margin-bottom: 8px;
  }
`;
